import { RoutemapMissedAlert } from '@/entities/alerts/card-missed';
import { RoutemapCloseAlert } from '@/entities/alerts/routemap-close';
import {
	TECH_CARD_CLOSED_STATUSES,
	TECH_CARD_ISSUE_DETAILS_STATUSES,
} from '@/pages/tech-card-operation/model/tech-card-operation.types';
import { selectExecutorsForOptions } from '@/entities/employee';
import { Loader } from '@/shared';
import { useGetAllExecutorsQuery, useGetAssemblyTechMapByIdQuery } from '@/shared/state/api/swagger';
import { OperationFillFormAssembly } from '@/widgets/operation/ui/operation-form-types/operation-fill-form/assembly';
import { useParams } from 'react-router-dom';
import { RoutemapRequestError } from '@/entities/alerts/routemap-request-error';
import { IssueDetailsFormAssembly } from '@/widgets/operation';

export const AssemblyTechmapOperationPage = () => {
	const { assemblyTechMapId } = useParams();
	const {
		data: techMap,
		isError: isTechMapError,
		isLoading: isTechMapLoading,
		error: techMapError,
	} = useGetAssemblyTechMapByIdQuery({ assemblyTechMapId: Number(assemblyTechMapId) });
	const { options: employees = [], isLoading: isEmployeesLoading } = useGetAllExecutorsQuery(
		{ stringToSearch: '' },
		{
			selectFromResult: (result) => ({
				...result,
				options: selectExecutorsForOptions(result?.data),
			}),
		},
	);

	if (isTechMapError) {
		if ('status' in techMapError && techMapError.status === 461) {
			return <RoutemapMissedAlert />;
		}
		return <RoutemapRequestError />;
	}

	if (isTechMapLoading || !techMap?.status || !techMap?.number || isEmployeesLoading || !techMap?.id) {
		return <Loader />;
	}

	// Если МК закрыта
	if (TECH_CARD_CLOSED_STATUSES.includes(techMap?.status)) {
		return <RoutemapCloseAlert variant="assembly" productTechMapNumber={techMap?.number} />;
	}

	return (
		<div>
			{TECH_CARD_ISSUE_DETAILS_STATUSES.includes(techMap?.status) && (
				<IssueDetailsFormAssembly mappedEmployees={employees} techMap={techMap} />
			)}
			{techMap?.status === 'progress' && <OperationFillFormAssembly techMap={techMap} employees={employees} />}
		</div>
	);
};
